import { ParsedUrlQuery } from 'querystring';
import { QUERY } from '@/constants/common';
import { VIP_ADS_PAGE_SLUG } from '@/hooks/usePageType/usePageType.constants';

export function shouldSkipSearchCategoryQuery(query: ParsedUrlQuery) {
  const { slug } = query;

  if (!slug || slug === VIP_ADS_PAGE_SLUG) {
    return true;
  }

  if (Array.isArray(slug) && slug[slug.length - 1] === VIP_ADS_PAGE_SLUG) {
    return true;
  }

  return Boolean(query[QUERY.userId]);
}
